import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const ArrowUpRightIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path className={`icon--${props.color}`} d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" />
    </IconSvgWrapper>
  );
};

export default ArrowUpRightIcon;
